import React from "react";

function ResumeDiv(props) {
  return (
    <div className="resume-divs" id={props.heading} onClick={props.handleClick}>
      <h2 className="h2-standard resume-headings"> {props.heading.replace("_"," ")} </h2>
      <img src={require(`../../media/${props.imageName}.png`).default} alt={props.heading} className="resume-icons" />
    </div>
  );
}

export default ResumeDiv;